import { json } from '@vercel/remix';
import type { LoaderFunctionArgs } from '@vercel/remix';
import type { LinksFunction, MetaFunction } from '@vercel/remix';
import { ClientOnly } from 'remix-utils/client-only';
import { Header } from '~/components/header/Header';
import { Homepage } from '~/components/Homepage.client';

export const meta: MetaFunction = () => {
  return [
    { title: 'Chef by Convex | Generate realtime full‑stack apps' },
    { name: 'description', content: 'Cook up something hot with Chef, the full-stack AI coding agent from Convex' },
    {
      property: 'og:image',
      content: '/social_preview_index.png',
    },
  ];
};

export const links: LinksFunction = () => [
  {
    rel: 'canonical',
    href: 'https://chef.convex.dev/projects',
  },
];

export const loader = async (args: LoaderFunctionArgs) => {
  const url = new URL(args.request.url);
  let code: string | null = url.searchParams.get('code');
  const state = url.searchParams.get('state');
  // If state is also set, this is probably the GitHub OAuth login flow finishing.
  // The code is probably not for us.
  if (state) {
    code = null;
  }
  return json({ code });
};

// Legacy home page for accessing existing Chef projects.
export default function Projects() {
  return (
    <div className="flex size-full flex-col bg-bolt-elements-background-depth-1">
      <Header />
      <ClientOnly>{() => <Homepage />}</ClientOnly>
    </div>
  );
}
